export default __webpack_public_path__ + "static/media/slot12.b12cee65.png";